import { ENVIRONMENT_CONSTANT } from "./env.constant";

export const SQUARE_ONBOARD_URL = `${ENVIRONMENT_CONSTANT.API_ENDPOINT}square/onboard`;
export const GET_SQUARE_DETAIL = `${ENVIRONMENT_CONSTANT.API_ENDPOINT}square/get`;
export const REVOKE_SQUARE_ACCOUNT = `${ENVIRONMENT_CONSTANT.API_ENDPOINT}square/revoke`;
export const SQUARE_INITIATE_PAYMENT = `${ENVIRONMENT_CONSTANT.API_ENDPOINT}square/payment`;